var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","xl":"12","xs":"12"}},[_c('v-skeleton-loader',{staticClass:"mx-auto border",attrs:{"type":_vm.type,"max-width":"auto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }